<div class="bg-gradient-to-r from-primary-200 via-primary-300 to-primary-400">
  <app-header></app-header>
  <main class="">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
  <nz-float-button-top nzType="primary" [nzVisibilityHeight]="20"
    [ngClass]="'back-to-top-button'"></nz-float-button-top>
</div>